<cl-popup title="Twoje zaufane urządzenia" [dialog]="dialogDef"
          closeAriaLabel="Zamknij okno dialogowe 'Twoje zaufane urządzenia'">
  <div *ngIf="duringLoading" class="trusted-device__loading">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="devices$ | async as devices" class="trusted-device__list">
    <cl-user-device
      *ngFor="let device of devices; let i = index"
      [device]="device"
      [index]="i +1"
      (removed)="removeDevice(device)"
      (nameChanged)="changeDeviceName(device, $event)">
    </cl-user-device>
  </div>
</cl-popup>
